module.exports = __webpack_public_path__ + "media/images/phone/writer-offering-title-e5fa9741401f68794e9024efbd75134a.png";